<template>
  <div class="gift-section">
    <component
      v-for="plugin in giftPlugins"
      :key="plugin.id"
      :is="plugin.component"
      :pluginId="plugin.id"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { getGiftPlugins } from './manager'

export default {
  name: 'GiftSection',
  inheritAttrs: false,
  computed: {
    giftPlugins() {
      console.log('=========', getGiftPlugins())
      return getGiftPlugins()
    },
  },
}
</script>

<style lang="less" scoped>
.gift-section {
  flex: 1;
}
</style>
